var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "keep-alive",
        [
          _c(
            "q-scroll-area",
            { staticStyle: { width: "100%", height: "calc(100vh - 106px)" } },
            [
              _c("i-q-form", {
                ref: "thisForm",
                attrs: { role: "icor" },
                on: {
                  after: _vm.onAfter,
                  submit: _vm.onSubmit,
                  cancel: _vm.onCancel
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }